var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVfLogoVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ebebeb;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M426.6,368.3v-153c0-13.6-7.3-26.2-19-33L351,149.6c31.4,28,50.3,69.7,47.3,115.8 c-4.6,70.6-61.6,127.9-132.1,132.8C182.9,404,113.4,338.1,113.4,256c0-42.2,18.4-80.2,47.5-106.2l-56.5,32.6 c-11.8,6.8-19,19.4-19,33v153c0,13.6,7.3,26.2,19,33l132.5,76.5c11.8,6.8,26.3,6.8,38.1,0l132.5-76.5 C419.2,394.5,426.6,381.9,426.6,368.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVfLogoVector);
export default __webpack_public_path__ + "static/media/VF_Logo_Vector.5cc1be97532823eac6b54ea563840385.svg";
export { ForwardRef as ReactComponent };